import { Button, Box } from '@mantine/core';
import { modals } from '@mantine/modals';
import ChartsEmbedSDK from '@mongodb-js/charts-embed-dom';
import { useEffect } from 'react';

import { MongoDashboardChartDetails } from './MongoDashboardChartDetails';
import classes from './MongoDashboardChart.module.css';

export const MongoDashboardChart = ({ chart, token, chartsBaseUrl }: { chart: any; token: string; chartsBaseUrl: string }) => {
  const { order } = chart;

  const renderChart = async (sdkChart) => {
    if (!document.getElementById(`chart-${order}`)) {
      return;
    }
    await sdkChart.render(document.getElementById(`chart-${order}`));
  };

  useEffect(() => {
    const sdk = new ChartsEmbedSDK({
      baseUrl: chartsBaseUrl,
      getUserToken: () => token,
    });

    const sdkChart = sdk.createChart({
      chartId: chart.chartId,
      height: '700px',
    });

    renderChart(sdkChart);
  }, [token, chartsBaseUrl]);

  const openChartModal = () => {
    modals.open({
      title: `Chart details - ${chart.name}`,
      children: <MongoDashboardChartDetails onHide={modals.closeAll} token={token} chart={chart} chartsBaseUrl={chartsBaseUrl} />,
      size: '60%',
      centered: true,
    });
  };

  return (
    <Box className={classes.container}>
      <Button type="submit" onClick={() => openChartModal()} variant="filled" size="lg">
        Details and actions
      </Button>
      <Box className={classes.chart} id={`chart-${order}`}></Box>
    </Box>
  );
};
